import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useState, useEffect } from 'react';
import keycode from 'keycode';
import Header from './_Header.js';
import { deviceWidths } from '../../variables/widths.js';
import useDisableScroll from '../../hooks/useDisableScroll.js';
import Body from './_Body.js';
import { PopUp } from './style/popUp.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Icon from '../Icon/Icon.js';
import { USER_INTERFACE_CROSS_CANCEL } from '../IconPath/USER_INTERFACE_CROSS_CANCEL.js';

var _excluded = ["closed", "close", "closeBottom", "header", "children", "defaultPadding"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var PopUpMobile = function PopUpMobile(props) {
  var closed = props.closed,
    close = props.close,
    closeBottom = props.closeBottom,
    header = props.header,
    children = props.children,
    defaultPadding = props.defaultPadding,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    disabledBodyScroll = _useState2[0],
    setDisabledBodyScroll = _useState2[1];
  var tabletWidth = +deviceWidths.tabletMax.replace('px', '');
  useDisableScroll(disabledBodyScroll);
  useEffect(function () {
    var onEvent = function onEvent(event) {
      if (closed) return;
      if (keycode(event) === 'esc') {
        if (window.innerWidth < tabletWidth) {
          close();
        }
      }
    };
    var handleOverflow = function handleOverflow() {
      if (closed) return;
      if (window.innerWidth < tabletWidth) {
        setDisabledBodyScroll(true);
      } else {
        setDisabledBodyScroll(false);
      }
    };
    var onResize = function onResize() {
      if (closed) return;
      handleOverflow();
    };
    handleOverflow();
    document.addEventListener('keydown', onEvent, false);
    window.addEventListener('resize', onResize, false);
    return function () {
      setDisabledBodyScroll(false);
      document.removeEventListener('keydown', onEvent, false);
      window.removeEventListener('resize', onResize, false);
    };
  }, [close, closed, tabletWidth]);
  var popupClick = function popupClick(e) {
    e.stopPropagation();
  };
  var closeClick = function closeClick(e) {
    e.stopPropagation();
    close();
  };
  if (closed || !children || !close && typeof close !== 'function') return null;
  return /*#__PURE__*/jsxs(PopUp, _objectSpread(_objectSpread({
    mobile: true,
    closed: closed,
    onClick: popupClick
  }, rest), {}, {
    children: [/*#__PURE__*/jsx(Header, {
      close: close,
      children: header
    }), /*#__PURE__*/jsx(Body, {
      defaultPadding: defaultPadding,
      children: children
    }), closeBottom && /*#__PURE__*/jsx(Icon, {
      className: "sg-popup-cancel-icon-bottom",
      path: USER_INTERFACE_CROSS_CANCEL,
      onClick: function onClick(e) {
        return closeClick(e);
      },
      role: "button"
    })]
  }));
};
PopUpMobile.defaultProps = {
  closed: true,
  close: null,
  className: null,
  header: null,
  children: null,
  closeBottom: false,
  defaultPadding: false
};
var PopUpMobile$1 = PopUpMobile;

export { PopUpMobile$1 as default };
//# sourceMappingURL=PopUpMobile.js.map
